import { render, staticRenderFns } from "./secBanner.vue?vue&type=template&id=5ec25b3a&scoped=true&"
import script from "./secBanner.vue?vue&type=script&lang=js&"
export * from "./secBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec25b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec25b3a')) {
      api.createRecord('5ec25b3a', component.options)
    } else {
      api.reload('5ec25b3a', component.options)
    }
    module.hot.accept("./secBanner.vue?vue&type=template&id=5ec25b3a&scoped=true&", function () {
      api.rerender('5ec25b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/invite/child/secBanner.vue"
export default component.exports